// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../Users/Giovanny Roman/AppData/Roaming/npm/node_modules/expo-cli/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".logoStyle {\r\n  margin-left: -1%;\r\n\r\n  height: 18rem;\r\n  width: 18rem;\r\n}\r\n.logoStylemap {\r\n  height: 10rem;\r\n  width: 10rem;\r\n}\r\n", ""]);
// Exports
module.exports = exports;
